(() => {
  const container=document.querySelector('.shopify-policy__container');
  if(!container||container.dataset.nativeRefundReady)return;
  container.dataset.nativeRefundReady='true';container.dataset.lplNativePage='policy';container.classList.add('lpl-native-refund');
  const body=container.querySelector('.shopify-policy__body'), rte=body?.querySelector('.rte'), first=rte?.firstElementChild;
  // Existing terms headings are strong elements separated by line breaks.
  // Apply the policy heading treatment without changing their text or order.
  rte?.querySelectorAll('strong,b').forEach(heading=>{
    if (/^(SECTION\s+\d+\s*[-–—]|OVERVIEW$)/i.test(heading.textContent.trim())) {
      heading.classList.add('lpl-native-policy-heading');
    }
  });
  if(container.dataset.policyPage==='california-privacy-act') {
    const headings=new Set([
      'What Personal Information Do We Collect?',
      'How Do We Use Your Personal Information?',
      'Do We Share Your Personal Information?',
      'Your CCPA Rights',
      'How to Exercise Your Rights',
      'Non-Discrimination',
      'Updates to This Privacy Notice',
      'Contact Us'
    ]);
    rte?.querySelectorAll(':scope > p').forEach(paragraph=>{
      if(!headings.has(paragraph.textContent.trim()))return;
      const heading=document.createElement('h2');
      for(const attribute of paragraph.attributes)heading.setAttribute(attribute.name,attribute.value);
      heading.append(...paragraph.childNodes);
      paragraph.replaceWith(heading);
    });
  }
  if(!first||!/^Summary:\s/.test(first.textContent))return;
  const original=first.textContent, parts=original.match(/^(Summary:)\s+(.+?\.)\s+([\s\S]+)$/);
  if(!parts)return;
  const aside=document.createElement('aside');aside.className='lpl-native-refund-summary';
  const left=document.createElement('div'),right=document.createElement('div');
  const label=document.createElement('span');label.className='lpl-native-refund-summary-label';label.textContent=parts[1];
  const lead=document.createElement('p');lead.className='lpl-native-refund-summary-lead';lead.textContent=parts[2];
  left.append(label,lead);
  const sentences=parts[3].match(/[^.!?]+[.!?]+|[^.!?]+$/g)||[parts[3]];
  sentences.forEach(sentence=>{const row=document.createElement('p');row.className='lpl-native-refund-summary-row';row.textContent=sentence.trim();right.append(row);});
  aside.append(left,right);
  // The visual split may not alter, abbreviate, or add any words.
  const text=[parts[1],parts[2],...sentences.map(s=>s.trim())].join(' ');
  if(text.replace(/\s+/g,' ').trim()!==original.replace(/\s+/g,' ').trim())return;
  body.insertBefore(aside,rte);first.remove();
})();
